import * as React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

import Card from "./structure/Card";


class Home extends React.Component {
  public render() {
    return (
      <Card title="Welcome!">Hello!
      <p><Link to="/login">Login</Link></p>
      </Card>
    );
  }
}


const mapStateToProps = function map(s: any) {
  return {};
};

function mapDispatchToProps(dispatch: any) {
  return {};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home)  as React.ComponentType<any>);


// WEBPACK FOOTER //
// ./src/components/Home.tsx